import { createSlice } from "@reduxjs/toolkit";
import { sendContact, getAllContactsAdmin, adminDeleteContact } from "./thunk";

const contactReducer = createSlice({
  name: "contact",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,

    contacts: [],
    pagination: null,
    adminLoading: false,
    deleteLoading: false,
  },
  reducers: {
    resetContact: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // SEND
      .addCase(sendContact.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendContact.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(sendContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })

      // GET ALL
      .addCase(getAllContactsAdmin.pending, (state) => {
        state.adminLoading = true;
      })
      .addCase(getAllContactsAdmin.fulfilled, (state, action) => {
        state.adminLoading = false;
        state.contacts = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getAllContactsAdmin.rejected, (state) => {
        state.adminLoading = false;
      })

      // DELETE
      .addCase(adminDeleteContact.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(adminDeleteContact.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.contacts = state.contacts.filter(
          (contact) => contact.id !== action.meta.arg,
        );
      })
      .addCase(adminDeleteContact.rejected, (state) => {
        state.deleteLoading = false;
      });
  },
});

export const { resetContact } = contactReducer.actions;
export default contactReducer.reducer;
